import { Alert } from '@mantine/core';
import type { AlertProps } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

export function ErrorAlert({ message, mb }: { message: string | null; mb?: AlertProps['mb'] }) {
  if (!message) return null;

  return (
    <Alert color="red" icon={<IconAlertCircle size={16} />} mb={mb}>
      {message}
    </Alert>
  );
}
